<template>
  <ValidationObserver :ref="id">
    <slot />
  </ValidationObserver>
</template>

<script>
    export default {
      name: "Form",
      props: {
        id: ''
      },
      mounted() {
        this.$emit('input', this.$refs[this.id]);
        this.$emit('formLoaded', this.$refs[this.id]);
      }
    }
</script>

<style scoped>

</style>
